import { http } from "./config";
import authHeader from "./auth-header";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

let stompClient = null;
let sonaxProtocolosSubscription = null;
let sonaxProtocolMessagesSubscription = null;

export default {
  // Autenticação (opcional, backend pode gerenciar automaticamente)
  authenticate: () => {
    return http.post(
      "/v2sonax/auth",
      {},
      {
        headers: authHeader(),
      },
    );
  },

  // Buscar templates
  getTemplates: (telefone) => {
    return http.get("/v2sonax/templates", {
      params: {
        telefone: telefone,
      },
      headers: authHeader(),
    });
  },

  // Enviar mensagem
  sendMessage: (data) => {
    return http.post("/v2sonax/send-message", data, {
      headers: authHeader(),
    });
  },

  sendMessageFile: ({ protocolo, to, from, file, fileUrl, isAudio = false }) => {
    const formData = new FormData();

    formData.append("protocolo", protocolo);
    formData.append("to", to);
    formData.append("from", from);

    // Adicionar file ou fileUrl dependendo do que foi fornecido
    if (file) {
      formData.append("file", file);
    }
    if (fileUrl) {
      formData.append("fileUrl", fileUrl);
    }
    
    formData.append("isAudio", isAudio);
    console.log(formData);
    return http.post("/v2sonax/send-message-file", formData, {
      headers: {
        ...authHeader(),
      },
    });
  },

  enviarBoletosEmLote: ({ protocolo, to, from, boletos }) => {
    return http.post(
      "/v2sonax/boletos/enviar-lote",
      {
        protocolo,
        to,
        from,
        boletos,
      },
      {
        headers: authHeader(),
      },
    );
  },

  // Buscar mensagens de um protocolo
  getMessages: (protocolNumber) => {
    return http.get("/v2sonax/messages", {
      params: {
        protocolNumber: protocolNumber,
      },
      headers: authHeader(),
    });
  },

  // Buscar mensagens por texto dentro de um protocolo
  searchMessages: (protocolNumber, query) => {
    return http.get("/v2sonax/messages/search", {
      params: {
        protocolNumber: protocolNumber,
        query: query,
      },
      headers: authHeader(),
    });
  },

  // Buscar protocolos em um período
  getProtocolsByStatus: (
    dtInicio,
    dtFim,
    status,
    telefone,
    empresa,
    idFila = [],
  ) => {
    const params = {
      dtInicio: dtInicio,
      dtFim: dtFim,
      status: status,
      telefone: telefone,
      empresa: empresa,
    };

    if (idFila.length) {
      params.idFila = idFila;
    }

    return http.get("/v2sonax/protocols-by-status", {
      params,
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => searchParams.append(key, item));
            return;
          }

          if (value !== null && value !== undefined && value !== "") {
            searchParams.append(key, value);
          }
        });

        return searchParams.toString();
      },
      headers: authHeader(),
    });
  },

  // Buscar protocolos da fila do chat sem impactar a tela de consulta.
  getChatProtocolsByStatus: (
    dtInicio,
    dtFim,
    status,
    telefone,
    empresa,
    idFila = [],
    meusAtendimentos = false,
  ) => {
    const params = {
      dtInicio: dtInicio,
      dtFim: dtFim,
      status: status,
      telefone: telefone,
      empresa: empresa,
      meusAtendimentos: meusAtendimentos,
    };

    if (idFila.length) {
      params.idFila = idFila;
    }

    return http.get("/v2sonax/chat/protocols-by-status", {
      params,
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => searchParams.append(key, item));
            return;
          }

          if (value !== null && value !== undefined && value !== "") {
            searchParams.append(key, value);
          }
        });

        return searchParams.toString();
      },
      headers: authHeader(),
    });
  },

  listarPainelProtocolos: (dtInicio, dtFim, empresa, telefone, protocolo, opcoes = {}) => {
    return http.get("/v2sonax/painel-protocolos", {
      params: {
        dtInicio,
        dtFim,
        empresa,
        telefone,
        protocolo,
        consultarDivergencia: opcoes.consultarDivergencia ? true : false,
        interacao: opcoes.interacao || "todos",
        ignorarCampanha: opcoes.ignorarCampanha ? true : false,
      },
      headers: authHeader(),
    });
  },

  fecharProtocolosLocal: (protocolNumbers) => {
    return http.post("/v2sonax/protocol/fechar-local", protocolNumbers, {
      headers: authHeader(),
    });
  },

  fecharProtocolosSonax: (protocolNumbers) => {
    return http.post("/v2sonax/protocol/fechar-sonax", protocolNumbers, {
      headers: authHeader(),
    });
  },

  // Fechar protocolo
  closeProtocol: (protocolId, protocolNumber, to, from) => {
    return http.post(
      "/v2sonax/protocol/close",
      {},
      {
        params: {
          protocolId: protocolId,
          to: to,
          from: from,
          protocolNumber: protocolNumber,
        },
        headers: authHeader(),
      },
    );
  },

  // Vincular atendimento ao protocolo
  vincularAtendimento: (protocolNumber) => {
    return http.post(
      `/v2sonax/protocol/${protocolNumber}/vincular-atendimento`,
      {},
      {
        headers: authHeader(),
      },
    );
  },

  // Desvincular atendimento do protocolo
  desvincularAtendimento: (protocolNumber, tipo) => {
    return http.post(
      `/v2sonax/protocol/${protocolNumber}/desvincular-atendimento/${tipo}`,
      {},
      {
        headers: authHeader(),
      },
    );
  },

  atualizarClienteNomeProtocolo: (protocolNumber, clienteNome) => {
    return http.post(
      `/v2sonax/protocol/${protocolNumber}/cliente-nome`,
      { clienteNome },
      {
        headers: authHeader(),
      },
    );
  },

  // Buscar contato por telefone
  searchContact: (telefone, from) => {
    return http.get("/v2sonax/search-contact", {
      params: {
        telefone: telefone,
        from: from,
      },
      headers: authHeader(),
    });
  },

  // Buscar protocolos por telefone
  getProtocolsByPhone: (numeroTelefone, from) => {
    return http.get("/v2sonax/protocols/by-phone", {
      params: {
        numeroTelefone: numeroTelefone,
        from: from,
      },
      headers: authHeader(),
    });
  },

  // Buscar mensagens por telefone
  getMessagesByPhone: (protocolo) => {
    return http.get("/v2sonax/messages/by-phone", {
      params: {
        protocolo: protocolo
      },
      headers: authHeader(),
    });
  },

  getMensagensPadrao: (empresa) => {
    return http.get("/v2sonax/mensagens-padrao", {
      params: {
        empresa: empresa,
      },
      headers: authHeader(),
    });
  },

  getMensagensPadraoAtivas: (empresa) => {
    return http.get("/v2sonax/mensagens-padrao/ativas", {
      params: {
        empresa: empresa,
      },
      headers: authHeader(),
    });
  },

  usarMensagemPadrao: (id, protocolo) => {
    return http.get(`/v2sonax/mensagens-padrao/${id}/usar`, {
      params: {
        protocolo: protocolo,
      },
      headers: authHeader(),
    });
  },

  salvarMensagemPadrao: (data) => {
    if (data.id) {
      return http.put(`/v2sonax/mensagens-padrao/${data.id}`, data, {
        headers: authHeader(),
      });
    }

    return http.post("/v2sonax/mensagens-padrao", data, {
      headers: authHeader(),
    });
  },

  excluirMensagemPadrao: (id) => {
    return http.delete(`/v2sonax/mensagens-padrao/${id}`, {
      headers: authHeader(),
    });
  },

  getClienteInfo: (valor, tipoBusca, empresa) => {
    return http.get("/v2sonax/info", {
      params: {
        valor: valor,
        tipoBusca: tipoBusca,
        empresa: empresa,
      },
      headers: authHeader(),
    });
  },

  // Buscar cliente na API iVertex pelo CPF/CNPJ
  obterClientePorCpf: (cpf) => {
    return http.get("/v2sonax/ivertx/cliente", {
      params: {
        cpf: cpf,
      },
      headers: authHeader(),
    });
  },

  obterEnderecoCep: (cep) => {
    return http.get("/v2sonax/ivertx/cep/" + cep, {
      headers: authHeader(),
    });
  },

  // Atualizar cliente na API iVertex
  atualizarCliente: (clienteDados) => {
    return http.post("/v2sonax/ivertx/cliente", clienteDados, {
      headers: authHeader(),
    });
  },

  // Salvar interação do cliente na API iVertex
  salvarInteracaoCliente: ({
    idEntidade,
    tipo,
    nomeContato,
    assunto,
    descricaoInteracao,
  }) => {
    return http.post(
      "/v2sonax/ivertx/interacao",
      {},
      {
        params: {
          idEntidade,
          tipo,
          nomeContato,
          assunto,
          descricaoInteracao,
        },
        headers: authHeader(),
      },
    );
  },

  // Gerar forma de pagamento
  gerarFormaPagamento: (
    idDocumento,
    telefone,
    from,
    formaPagamento,
    protocolo,
  ) => {
    const params = {};
    if (telefone) params.telefone = telefone;
    if (from) params.from = from;
    if (formaPagamento) params.forma_pagamento = formaPagamento;
    if (protocolo) params.protocolo = protocolo;

    return http.post(
      `/v2sonax/gerar-forma-pagamento/${idDocumento}`,
      {},
      {
        params: params,
        headers: authHeader(),
      },
    );
  },

  transferirAtendimento: (protocolNumber, novoAtendente) => {
    return http.post(
      `/v2sonax/protocol/${protocolNumber}/transferir-atendimento`,
      {},
      {
        params: {
          novoAtendente: novoAtendente,
        },
        headers: authHeader(),
      },
    );
  },
  transferirAtendimentoFila: (protocolNumber, novaFila) => {
    return http.post(
      `/v2sonax/protocol/${protocolNumber}/alterar-fila`,
      {},
      {
        params: {
          idFila: novaFila,
        },
        headers: authHeader(),
      },
    );
  },

  adicionarVisitante: (protocolNumber, visitante) => {
    return http.post(
      `/v2sonax/protocol/${protocolNumber}/adicionar-visitante`,
      {},
      {
        params: {
          visitante: visitante,
        },
        headers: authHeader(),
      },
    );
  },

  removerVisitante: (protocolNumber) => {
    return http.post(
      `/v2sonax/protocol/${protocolNumber}/remover-visitante`,
      {},
      {
        headers: authHeader(),
      },
    );
  },

  getInteracoes: (dataInicio, dataFim) => {
    return http.get(`/v2sonax/interacoes`, {
      params: {
        dataInicio: dataInicio,
        dataFim: dataFim,
      },
      headers: authHeader(),
    });
  },

  preencherParametros(templateNome, telefone) {
    return http.get(`/v2sonax/parametros/${templateNome}`, {
      params: { telefone: telefone },
      headers: authHeader(),
    });
  },

  listarTemplateParametros: () => {
    return http.get("/v2sonax/template-parametros", {
      headers: authHeader(),
    });
  },

  obterTemplateParametrosPorId: (id) => {
    return http.get(`/v2sonax/template-parametros/${id}`, {
      headers: authHeader(),
    });
  },

  salvarTemplateParametros: (payload) => {
    return http.post("/v2sonax/template-parametros", payload, {
      headers: authHeader(),
    });
  },

  excluirTemplateParametros: (id) => {
    return http.delete(`/v2sonax/template-parametros/${id}`, {
      headers: authHeader(),
    });
  },

  salvarFilaTemplate: (request) => {
    return http.post("/v2sonax/fila-template", request, {
      headers: authHeader(),
    });
  },

  // Listar todas as filas template
  listarFilaTemplates: () => {
    return http.get("/v2sonax/fila-template", {
      headers: authHeader(),
    });
  },
  // Listar todas as filas template
  listarFilaTemplatesEmpresa: (empresa) => {
    return http.get(`/v2sonax/fila-template/${empresa}`, {
      headers: authHeader(),
    });
  },

  finalizarCampanha(telefoneNumber, campanhaName) {
    return http.post("/v2sonax/campanha/close-protocolos-por-campanha", null, {
      params: {
        campanhaName: campanhaName,
        telefoneNumber: telefoneNumber,
      },
      headers: authHeader(),
    });
  },

  // Sincronizar protocolos
  sincronizarProtocolos(empresa) {
    return http.post("/v2sonax/sincronizar", null, {
      params: {
        empresa: empresa,
      },
      headers: authHeader(),
    });
  },

  /* ===========================
   * WEBSOCKET SONAX V2
   * =========================== */

  connectWebSocket(callbacks = {}) {
    if (stompClient && stompClient.connected) {
      callbacks.onConnect?.(null, stompClient);
      return stompClient;
    }

    sonaxProtocolosSubscription = null;

    const wsUrl = `${http.defaults.baseURL.replace(/\/$/, "")}/ws`;
    const socket = new SockJS(wsUrl);
    stompClient = Stomp.over(socket);

    stompClient.debug = () => {};

    stompClient.connect(
      authHeader() || {},
      (frame) => {
        callbacks.onConnect?.(frame, stompClient);
      },
      (error) => {
        sonaxProtocolosSubscription = null;
        stompClient = null;
        callbacks.onError?.(error);
      },
    );

    return stompClient;
  },

  subscribeProtocolosSonax(callback) {
    if (!stompClient || !stompClient.connected) {
      return null;
    }

    if (sonaxProtocolosSubscription) {
      return sonaxProtocolosSubscription;
    }

    sonaxProtocolosSubscription = stompClient.subscribe(
      "/topic/sonax/protocolos",
      (message) => {
        let payload = {};

        try {
          payload = JSON.parse(message.body);
        } catch (error) {
          payload = { body: message.body };
        }

        callback?.(payload);
      },
    );

    return sonaxProtocolosSubscription;
  },

  unsubscribeProtocolMessagesSonax() {
    if (sonaxProtocolMessagesSubscription) {
      sonaxProtocolMessagesSubscription.unsubscribe();
      sonaxProtocolMessagesSubscription = null;
    }
  },

  subscribeProtocolMessagesSonax(protocolNumber, callback) {
    if (!stompClient || !stompClient.connected || !protocolNumber) {
      return null;
    }

    this.unsubscribeProtocolMessagesSonax();

    sonaxProtocolMessagesSubscription = stompClient.subscribe(
      `/topic/sonax/protocolos/${protocolNumber}/mensagens`,
      (message) => {
        let payload = {};

        try {
          payload = JSON.parse(message.body);
        } catch (error) {
          payload = { body: message.body };
        }

        callback?.(payload);
      },
    );

    return sonaxProtocolMessagesSubscription;
  },

  disconnectWebSocket() {
    this.unsubscribeProtocolMessagesSonax();

    if (sonaxProtocolosSubscription) {
      sonaxProtocolosSubscription.unsubscribe();
      sonaxProtocolosSubscription = null;
    }

    if (stompClient) {
      stompClient.disconnect(() => {
        stompClient = null;
      });
    }
  },
};
